import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../../shared/helpers/icons';
import { ISchedule } from '../../../../shared/models/schedule';
import { UserDataService } from '../../../../shared/services/userData.service';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateUtils } from '../../../../shared/helpers/dateUtils';
import { IUserInfo } from '../../../../shared/models/contact';
import { NoEmojiDirective } from '../../../../shared/helpers/noEmoji.directive';
declare var initFlowbite: any;

@Component({
  selector: 'schedule-table',
  standalone: true,
  imports: [
    LucideAngularModule,
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    NoEmojiDirective
  ],
  templateUrl: './schedule-table.component.html',
  styleUrl: './schedule-table.component.css'
})
export class ScheduleTableComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @Input() schedulesList: ISchedule[] = [];
  @Output() onOpenModal = new EventEmitter<{ modalName: string, selectedItem?: ISchedule }>();
  @Output() onSchoolYearChange = new EventEmitter<string>();

  icons = Icons;

  searchQuery: string = '';
  filteredSchedulesList: ISchedule[] = [];
  currentSchedule: ISchedule | null = null;
  buildingId: string | null = null;
  currentUser: IUserInfo | null = null;
  messageModal: string | null = null;
  popupMessage: string | null = null;
  message: string | null = null;
  page = 1;
  itemsPerPage = 10;
  schoolYears: string[] = [];
  selectedSchoolYear: string = '';

  loading: boolean = false;
  sortOrder: boolean = true;
  showHistory: boolean = false;
  isSchoolYearDropdownOpen = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private userDataService: UserDataService,
  ) {}

  ngOnInit(): void {
    this.currentUser = this.userDataService.getUserData();
    document.addEventListener('click', this.handleClickOutside);
    this.schoolYears = DateUtils.getSchoolYears(6);
    this.selectedSchoolYear = DateUtils.getCurrentSchoolYear();
  }
  
  ngOnDestroy(): void {
    document.removeEventListener('click', this.handleClickOutside);
  }
  
  handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest('#schoolYearDropdownButton') && !target.closest('#schoolYearDropdown')) {
      this.isSchoolYearDropdownOpen = false;
    }
  };  

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['schedulesList']) {
      this.filteredSchedulesList = [...this.schedulesList];
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => initFlowbite(), 0);
    }
  }

  sortList(key: keyof typeof this.filteredSchedulesList[0]): void {
    this.sortOrder = !this.sortOrder;
    this.filteredSchedulesList.sort((a, b) => {
      const valueA = a[key]?.toString().toLowerCase() || '';
      const valueB = b[key]?.toString().toLowerCase() || '';

      if (valueA < valueB) {
        return this.sortOrder ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortOrder ? 1 : -1;
      }
      return 0;
    });
  }
  
  toggleSchoolYearDropdown(): void {
    this.isSchoolYearDropdownOpen = !this.isSchoolYearDropdownOpen;
  }

  handleSchoolYearSelect(year: string): void {
    this.selectedSchoolYear = year;
    this.isSchoolYearDropdownOpen = false;
    this.onSchoolYearChange.emit(year);
  }

  filterSchedulesList(): void {
    this.filteredSchedulesList = this.schedulesList.filter((item) => {
      return (
        item.type_name.toLowerCase()
          .includes(this.searchQuery.toLowerCase()) ||
        item.name?.toLowerCase()
          .includes(this.searchQuery.toLowerCase()) ||
        item.last_updated_user_name?.toLowerCase()
          .includes(this.searchQuery.toLowerCase()) ||
        item.last_updated_at?.toLowerCase()
          .includes(this.searchQuery.toLowerCase()) ||
        item.duration?.toString().toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    });
  }

  handleBtnClick(modalName: string, selectedItem?: ISchedule): void {
    this.onOpenModal.emit({ modalName, selectedItem });
  }
  
  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
  }
  
  canSave(): boolean {
    if (!this.currentUser) return false;
    return this.currentUser.can_edit || this.currentUser.can_admin;
  }


}
